import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Navbar from '../Navbar';
import Drawer from '../Drawer';
import DivContainer from './Layout.styled';

export default function Layout({ children }) {
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <DivContainer>
      <Navbar toggleDrawer={setOpenDrawer} />
      <Drawer open={openDrawer} toggleDrawer={setOpenDrawer} />
      {children}
    </DivContainer>
  );
}

Layout.propTypes = {
  children: PropTypes.element.isRequired,
};
